// extracted by mini-css-extract-plugin
export default {"grid":"SellTips-grid","tip":"SellTips-tip","iconWrap":"SellTips-iconWrap"};